const config = {
  baseUrl: process.env.VUE_APP_BASE_URL || "/",
  apiUrl: process.env.VUE_APP_BASE_API_URL || "/",
};

export default config;
